
<div class="is-flex gap-8 is-column is-align-center">
  <app-text class="text-12 is-family-medium">N</app-text>
  @if (windAngle() === -1) {
    <img [ngSrc]="windIcon()" width="32" height="32">
    <p class="text-12 text-grey-70">{{ noWindText() | AsyncLang | async }}</p>
  }
  @else {
    <svg [style.transform]="'rotate(' + windAngle() + 'deg)'" width="34" height="36" viewBox="0 0 34 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path d="M21.0000001,21.8207694 L10.7566231,18.1980703 C8.72812426,17.7197141 6.94476982,19.399965 7.72151484,21.0986913 L19.1031707,45.7539692 C20.0585088,47.5691898 21.9411662,47.5691898 22.897056,45.7539692 L34.2787118,21.0986913 C35.0549052,19.399965 33.2715508,17.7197141 31.2436036,18.1980703 L21.0000001,21.8207694 Z"
          id="path-1" />
        <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-2">
          <feMorphology radius="1" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1" />
          <feOffset dx="0" dy="-2" in="shadowSpreadOuter1"
            result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1"
            result="shadowBlurOuter1" />
          <feComposite in="shadowBlurOuter1" in2="SourceAlpha"
            operator="out" result="shadowBlurOuter1" />
          <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0"
            type="matrix" in="shadowBlurOuter1" />
        </filter>
      </defs>
      <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Pin-blue" transform="translate(-4.000000, -15.000000)">
          <g id="Shape-Copy-20">
            <use fill="black" fill-opacity="1" filter="url(#filter-2)" xlink:href="#path-1" />
            <use [attr.fill]="windColor()" fill-rule="evenodd" xlink:href="#path-1" />
            <use stroke="#FFFFFF" stroke-width="2" xlink:href="#path-1" />
          </g>
        </g>
      </g>
    </svg>
    <app-text class="text-12 text-grey-70">{{ windDirection() }} ({{ windAngle() ?? '--' }}°)</app-text>
  }
</div>
